require('./_index');
require('./_events-view');
require('./_events-list');
require('./_publishing-house');
require('./catalog/index');
require('./catalog/company');
require('./contacts');
require('./cart');
require('./learning/index');
require('./news/index');